// extracted by mini-css-extract-plugin
module.exports = {"biographyHeader":"styles_biographyHeader__80TV0","imgContainer":"styles_imgContainer__oCsSl","text":"styles_text__lWp3B"};